import { useLocation, Navigate, useParams } from "react-router-dom";
import useAuth from "../hooks/use.auth";
import { usePermissao } from "@/utils/permissao";
import { ErrorPage } from "@/pages/ErrorPage";

export function RequireTenant({ children }: { children: JSX.Element }) {
  let {tenant} = useParams();
  let auth = useAuth();
  let location = useLocation();

  if (!tenant && auth.user) {
    return <Navigate to={`/${auth.user.empresas![0].id}`} state={{ from: location }} replace />;
  }

  return children;
}

// Tela acessada pela URL sem a permissão: mesma página do 403 da API
export function RequirePermissao({ permissao, children }: { permissao: string; children: JSX.Element }) {
  return usePermissao(permissao) ? children : <ErrorPage statusCode={403} />;
}
